import MailIcon from '@material-design-icons/svg/filled/email.svg?component'
import HomeIcon from '@material-design-icons/svg/filled/home.svg?component'
import PhoneIcon from '@material-design-icons/svg/filled/phone.svg?component'
import SmartphoneIcon from '@material-design-icons/svg/filled/phone_iphone.svg?component'
import VideoIcon from '@material-design-icons/svg/filled/videocam.svg?component'
import { MdNoteAlt as ClipboardEditIcon, MdEditDocument as FileEdit } from 'react-icons/md'

import GrandRoundsIcon from '../../../../assets/svgs/grandrounds.svg?component'
import RIcon from '../../../../assets/svgs/r.svg?component'
import { SystemRoles } from '../../../../lib/Codes'
import { FriendlyDateTime } from '../../../shared/Date/friendly-date-time'

const style = {
  marginBottom: '20px',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start'
}

const icons = {
  patient: '',
  home: (
    <HomeIcon
      fill='#82B43C'
      style={{ transform: 'scale(0.85)' }}
    />
  ),
  cms: (
    <RIcon
      fill='#82B43C'
      style={{ position: 'relative', left: -3 }}
    />
  ),
  APS: (
    <RIcon
      fill='#82B43C'
      style={{ position: 'relative', left: -3 }}
    />
  ),
  research: (
    <RIcon
      fill='#82B43C'
      style={{ position: 'relative', left: -3 }}
    />
  ),
  phone: (
    <PhoneIcon
      fill='#82B43C'
      style={{ transform: 'scale(0.85)' }}
    />
  ),
  virtual: (
    <VideoIcon
      fill='#82B43C'
      style={{ transform: 'scale(0.85)' }}
    />
  ),
  administrative: (
    <ClipboardEditIcon
      color='#82B43C'
      size='1.1rem'
    />
  ),
  grandRounds: (
    <GrandRoundsIcon />
  ),
  edit: (
    <FileEdit
      color='#82B43C'
      size='1.1rem'
    />
  ),
  email: (
    <MailIcon
      fill='#82B43C'
      style={{ transform: 'scale(0.85)' }}
    />
  ),
  mobile: (
    <SmartphoneIcon
      fill='#82B43C'
      style={{ transform: 'scale(0.85)' }}
    />
  )
}

const Narrative = ({ narrative }) => {
  let suffixes = ''
  if (narrative.name && narrative.name.suffix) {
    suffixes = narrative.name.suffix.join(', ')
  }
  const roleLabel = SystemRoles.find(sr => sr.code === narrative.role).label
  if (narrative.type === 'Research') { narrative.type = 'research' }
  return (
    <div style={style}>
      {icons[narrative.type]}
      <div style={{ marginLeft: '5px' }}>
        <span
          style={{
            fontSize: 12,
            color: 'grey'
          }}
        >
          {narrative.name.given}
          {' '}
          {narrative.name.family}
          {' '}
          {suffixes}
          {' '}
          <span style={{ backgroundColor: '#FFDEAD' }}>{roleLabel}</span>
          {' '}
          <FriendlyDateTime
            full
            datetime={narrative.date}
          />
        </span>
        <p style={{ margin: 0 }}>{narrative.narrative}</p>
      </div>
    </div>
  )
}

export default Narrative
